// TODO: Remove THE
export var TheOfferMainDriver;
(function (TheOfferMainDriver) {
    TheOfferMainDriver["POLICYHOLDER"] = "policyHolder";
    TheOfferMainDriver["POLICYHOLDER_PARTNER"] = "policyHolderPartner";
    TheOfferMainDriver["POLICYHOLDER_PARTNER_CHILDREN"] = "policyHolderPartnerChildren";
})(TheOfferMainDriver || (TheOfferMainDriver = {}));
(function (TheOfferMainDriver) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.enum.mainDriver.POLICYHOLDER'),
                value: TheOfferMainDriver.POLICYHOLDER,
            },
            {
                label: t('wheelie:form.enum.mainDriver.POLICYHOLDER_PARTNER'),
                value: TheOfferMainDriver.POLICYHOLDER_PARTNER,
            },
            {
                label: t('wheelie:form.enum.mainDriver.POLICYHOLDER_PARTNER_CHILDREN'),
                value: TheOfferMainDriver.POLICYHOLDER_PARTNER_CHILDREN,
            },
        ];
    }
    TheOfferMainDriver.createOptions = createOptions;
    function translate(t, value) {
        return t(`wheelie:form.enum.mainDriver.${value}`);
    }
    TheOfferMainDriver.translate = translate;
})(TheOfferMainDriver || (TheOfferMainDriver = {}));
export var PolicyRecipientCopy;
(function (PolicyRecipientCopy) {
    PolicyRecipientCopy["COPY"] = "copy";
    PolicyRecipientCopy["NO_COPY"] = "no_copy";
})(PolicyRecipientCopy || (PolicyRecipientCopy = {}));
(function (PolicyRecipientCopy) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.enum.policy_recipient_copy.COPY'),
                value: PolicyRecipientCopy.COPY,
            },
            {
                label: t('wheelie:form.enum.policy_recipient_copy.NO_COPY'),
                value: PolicyRecipientCopy.NO_COPY,
            },
        ];
    }
    PolicyRecipientCopy.createOptions = createOptions;
    function translate(t, value) {
        return t(`wheelie:form.enum.policy_recipient_copy.${value}`);
    }
    PolicyRecipientCopy.translate = translate;
    function getDefault() {
        return PolicyRecipientCopy.NO_COPY;
    }
    PolicyRecipientCopy.getDefault = getDefault;
})(PolicyRecipientCopy || (PolicyRecipientCopy = {}));
// TODO: request for offer/contract
export var RequestType;
(function (RequestType) {
    RequestType["NEUANTRAG"] = "Neuantrag";
    RequestType["ERSATZANTRAG"] = "Ersatzantrag";
})(RequestType || (RequestType = {}));
(function (RequestType) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.enum.requestType_order.NEUANTRAG'),
                value: RequestType.NEUANTRAG,
            },
            {
                label: t('wheelie:form.enum.requestType_order.ERSATZANTRAG'),
                value: RequestType.ERSATZANTRAG,
            },
        ];
    }
    RequestType.createOptions = createOptions;
})(RequestType || (RequestType = {}));
